import React from 'react'
import { isEmpty } from 'lodash'
import { StreamData } from 'types/streamData'
import InternalContentComponent from './InternalContentComponent'
import VocComingSoon from './VocComingSoon'
import Divider from '../Divider'

type InternalContentsProps = {
  streamData: StreamData
  highlighting?: boolean
}

const InternalContents = ({ streamData, highlighting }: InternalContentsProps) => {
  const { internalContents, reviewData } = streamData

  const contentLength = (internalContents || []).length
  const isLastContent = (index: number) => index === contentLength - 1

  return (
    <>
      {(internalContents || []).map((internalContent, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={index}>
          <InternalContentComponent
            vocSentence={internalContent}
            highlighting={highlighting}
            index={index}
          />
          {!isLastContent(index) && <Divider />}
        </React.Fragment>
      ))}
      {!isEmpty(reviewData) && (
        <>
          <Divider />
          <VocComingSoon />
        </>
      )}
    </>
  )
}

export default InternalContents
